import axios from "axios";
import qs from "query-string";
interface T {
  code: number;
  message: string;
}
export const checkPassword: (params: { password: string }) => Promise<T> =
  async (params: { password: string }) => {
    const encrypt = window.__authing__.options.encryptFunction;
    const publicKey = window.__config__.publicKey;
    //   alert(password);
    const encryptPassword = await encrypt!(params.password, publicKey);
    const pswd = qs.stringify({ password: encryptPassword });
    const token = localStorage.getItem("_authing_token") || "";
    const data: any = await axios.get("api/v2/users/password/check?" + pswd, {
      headers: {
        Authorization: token,
      },
    });

    return data;
  };
